import React, { useEffect, useRef } from 'react'
import '../App.css';
import '../styles/mainpage.css';
// import "bootstrap/dist/css/bootstrap-utilities.css";
// import { Carousel } from 'react-bootstrap';
import image1 from '../img/4.jpeg';
import image2 from '../img/5.jpeg';
import image3 from '../img/Kitchen/Kitchen 8.jpg';
import image4 from '../img/Planning/Planning 10.jpg';
import image5 from '../img/RK Designs.png';
import background from '../img/background.jpeg';
// import image6 from '../img/1.jpeg';
// import image7 from '../img/Planning/Planning 1.jpg';
// import image8 from '../img/Planning/planning 7.jpg';


function Mainpage() {

    const elementsRef = useRef([]);
    const imageGroupRef = useRef(null);

  useEffect(() => {
    const elements = elementsRef.current;

    function handleAnimationEnd() {
      elements[0].style.animation = `flip 2s linear 2s forwards`;
    }

    function handleImageAnimationEnd(event) {
      const element = event.target;
      const computedStyles = window.getComputedStyle(element);
      const hasStyle = computedStyles.getPropertyValue("animation-name");
      const index = elements.indexOf(element);

      if (index === elements.length - 2) {
        if (hasStyle === "flip") {
          element.style.animation = `backflip 0.5s ease-in-out 2s backwards`;
        } else {
          elements[index - 1].style.animation = `backflip 0.5s ease-in-out backwards`;
        }
      } else {
        if (hasStyle === "flip") {
          elements[index + 1].style.animation = `flip 2s ease-in-out 2s forwards`;
        } else {
          if (index === 1) {
            elements[index].style.animation = `flip 2s ease-in-out 2s forwards`;
          } else {
            elements[index - 1].style.animation = `backflip 0.5s 1s ease-in-out backwards`;
          }
        }
      }
    }

    elements.forEach((element, index) => {
      element.addEventListener("animationend", handleImageAnimationEnd);
    });
    imageGroupRef.current.addEventListener("animationend", handleAnimationEnd);

    return () => {
      elements.forEach((element, index) => {
        element.removeEventListener("animationend", handleImageAnimationEnd);
      });
      imageGroupRef.current.removeEventListener("animationend", handleAnimationEnd);
    };
  }, []);
  

    return (
        <section className="section" id="Home">
            <div className="cont">
                <div className="left-side">
                    <h1>Welcome to <span>RK Designs</span></h1>
                    <p className="tagline1" style={{textAlign: "center", marginBottom:"20px"}}>If you can dream it, we can build it!</p>
                    <p>We create unique and sustainable designs that inspire and delight, from residential homes to commercial
                        properties looking to bring your vision to life? Contact us for a consultation and let's create something
                        incredible together.</p>
                </div>

                <div className="image-group right-side" ref={imageGroupRef}>
                    <div className="a1">
                        <img className="image" id="image1" src={image1} alt="" ref={(el) => (elementsRef.current[4] = el)}/>
                    </div>
                    <div className="a1">
                        <img className="image" id="image2" src={image3} alt="" ref={(el) => (elementsRef.current[3] = el)}/>
                    </div>
                    <div className="a1">
                        <img className="image" id="image3" src={image4} alt="" ref={(el) => (elementsRef.current[2] = el)}/>
                    </div>
                    <div className="a1">
                        <img className="image" id="image4" src={image2} alt="" ref={(el) => (elementsRef.current[1] = el)}/>
                    </div>
                    <div className="a1">
                        <img className="image" id="image5" src={image5} alt="" ref={(el) => (elementsRef.current[0] = el)}/>
                    </div>
                </div>
            </div>
            <div className="box">
              <img src={background} className="backgroundImage" alt="Rk designs" style={{zIndex : "-1"}} />
            </div>
            {/* <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={image6} className="d-block w-100" alt="RK Designs" />
                    </div>
                    <div className="carousel-item">
                        <img src={image7} className="d-block w-100" alt="RK Designs" />
                    </div>
                    <div className="carousel-item">
                        <img src={image8} className="d-block w-100" alt="RK Designs" />
                    </div>
                    <div className="carousel-item">
                        <img src={image1} className="d-block w-100" alt="RK Designs" />
                    </div>
                </div>
            </div> */}

        </section>
    )
}

export default Mainpage
